import map from 'lodash/map';
import get from 'lodash/get';
import groupBy from 'lodash/groupBy';
import padStart from 'lodash/padStart';

export function secondsToMin (seconds) {
	const mins = Math.floor(seconds / 60)
	const secs = seconds - mins * 60
  return `${padStart(mins, 2, '0')}:${padStart(secs, 2, '0')}`
}

// Check if a number is between two others
export function isBetween (current, start, end) {
	return current >= start && current < end
}

// Limit a number to min and max value
export function between (value, min, max) {
	return Math.min(Math.max(min, value), max)
}

export function titleClickToStart (value) {
	return `Click to play film from ${secondsToMin(value)}`
}